import { ItemType } from '@wix/wix-vod-constants/api-types';
import { LIVE_VIDEO_STATUS } from '@wix/wix-vod-constants/common';
export const mapMediaInfoToLiveVideoStatus = (mediaInfo, itemType) => {
    const status = mediaInfo?.fileOutput?.video[0]?.status;
    const isLiveVideo = itemType === ItemType.ItemLive;
    return isLiveVideo ? LIVE_VIDEO_STATUS[status] : undefined;
};
//# sourceMappingURL=mapMediaInfoToLiveStatus.js.map